import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponseEnvelope } from '@doctor-scheduling/shared/models';
import { API_BASE_URL } from './api-base-url.token';

/** Entity kind returned by global search. */
export type GlobalSearchHitType = 'patient' | 'doctor' | 'appointment';

/** One global search hit. */
export interface GlobalSearchHit {
  id: string;
  type: GlobalSearchHitType;
  recordId: string;
  title: string;
  subtitle: string;
  route: string;
}

/** Envelope payload for `GET /search`. */
export interface GlobalSearchPayload {
  result: GlobalSearchHit[];
  itemCount: number;
}

/** HTTP client for clinic global search. */
@Injectable({
  providedIn: 'root',
})
export class GlobalSearchApi {
  /** Angular HTTP client. */
  private readonly http = inject(HttpClient);
  /** NestJS API origin from the web app environment. */
  private readonly apiBaseUrl = inject(API_BASE_URL);
  /** Search API base under `/api/v1/search`. */
  private readonly baseUrl = `${this.apiBaseUrl}/api/v1/search`;

  /**
   * Runs a free-text clinic search.
   * @param q - Query string
   * @returns API envelope with hits
   */
  search(q: string): Observable<ApiResponseEnvelope<GlobalSearchPayload>> {
    const params = new HttpParams().set('q', q);
    return this.http.get<ApiResponseEnvelope<GlobalSearchPayload>>(this.baseUrl, {
      params,
    });
  }
}
